import { useState, useEffect } from 'react';

const VAPID_PUBLIC_KEY = 'BI-YzXbf3wc8-nPjvfdq921GTvBRuOVDBG2Qq_wk0DVOzRKZMOV8amA-SG2R7Avvu27JIbDa4OAYOfFwtb3Fh2M';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map(c => c.charCodeAt(0)));
}

export default function PushManager() {
  const [show, setShow] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  useEffect(() => {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
    if (Notification.permission === 'granted') {
      // Ya tiene permiso, registrar silenciosamente
      subscribe();
    } else if (Notification.permission !== 'denied') {
      setShow(true);
    }
  }, []);

  const subscribe = async () => {
    try {
      const reg = await navigator.serviceWorker.ready;

      const existing = await reg.pushManager.getSubscription();
      if (existing) { setSubscribed(true); setShow(false); return; }

      const permission = await Notification.requestPermission();
      if (permission !== 'granted') { setShow(false); return; }

      const subscription = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
      });

      const sub = subscription.toJSON();
      const apiUrl = process.env.REACT_APP_API_URL;
      // Obtener msisdn del localStorage si existe
      let msisdn = '';
      try {
        const saved = localStorage.getItem('formData');
        if (saved) msisdn = JSON.parse(saved).msisdn || '';
      } catch {}

      await fetch(`${apiUrl}/prod/push_subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          endpoint: sub.endpoint,
          p256dh: sub.keys.p256dh,
          auth: sub.keys.auth,
          msisdn,
        }),
      });

      setSubscribed(true);
      setShow(false);
    } catch (err) {
      console.error('Error registrando push:', err);
      setShow(false);
    }
  };

  if (!show || subscribed) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 80,
      left: 16,
      right: 16,
      padding: '14px 18px',
      background: '#1b2938',
      color: '#fff',
      borderRadius: 14,
      zIndex: 1001,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 12,
      boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
    }}>
      <span style={{ fontSize: 14 }}>🔔 ¿Quieres recibir ofertas y promociones?</span>
      <div style={{ display: 'flex', gap: 8 }}>
        <button
          onClick={subscribe}
          style={{ padding: '8px 16px', background: '#22c55e', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, cursor: 'pointer', fontSize: 13 }}
        >
          Sí
        </button>
        <button
          onClick={() => setShow(false)}
          style={{ padding: '8px 12px', background: 'transparent', color: '#9ca3af', border: '1px solid #4b5563', borderRadius: 8, cursor: 'pointer', fontSize: 13 }}
        >
          No
        </button>
      </div>
    </div>
  );
}
